import React, { useState, useLayoutEffect } from 'react'
import config from '../app-config'
import { MdExitToApp, MdPerson, MdNotifications, MdSettings } from 'react-icons/md'
import { logout, useFetchUserData } from '../utils/AppFunctions'
import { isMobile } from '../utils/helper'
import { useNavigate } from 'react-router-dom'

export default function AdminHeader({ showNavbar, setShowNavbar }) {
    const [imageHeight, setImageHeight] = useState(document.getElementById("logo-navbar")?.getClientRects()[0].bottom)
    const user_data = useFetchUserData()
    const navigate = useNavigate()

    useLayoutEffect(() => {
        setImageHeight(document?.getElementById("logo-navbar")?.getClientRects()[0].bottom)
    }, [imageHeight])



    const admin_context_menu = [
        // {
        //     title: "Profile",
        //     icon: <MdPerson size={20} color='gray' />,
        //     onClick: () => { window.location.href = "/profile" }
        // },
        {
            title: "Logout",
            icon: <MdExitToApp size={20} color='gray' />,
            onClick: () => { logout() }
        }
    ]

    const [showMenu, setShowMenu] = useState(false)

    return (
        <>
            {/* Modern Admin Header */}
            <header className="sticky top-0 z-50 bg-white shadow-lg border-b border-gray-200" id='user-header'>
                <div className="mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center justify-between h-16">
                        {/* Mobile Logo & Menu Trigger */}
                        {isMobile(window.innerWidth) && (
                            <div className="flex items-center space-x-3">
                                <button
                                    onClick={() => setShowNavbar(true)}
                                    className="p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200"
                                >
                                    <img 
                                        src={config.images.default.logo_white} 
                                        alt="BMC Logo" 
                                        className="h-8 w-auto object-contain filter brightness-0 invert-0"
                                        id="logo-navbar"
                                    />
                                </button>
                            </div>
                        )}

                        {/* Right Side - User Profile & Actions */}
                        <div className="flex items-center justify-end w-full space-x-4">
                            {/* Notifications Button */}
                            {/* <button className="relative p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200 group">
                                <MdNotifications size={20} className="text-gray-600 group-hover:text-gray-800" />
                                <span className="absolute -top-1 -right-1 h-3 w-3 bg-red-500 rounded-full"></span>
                            </button> */}

                            {/* Settings Button */}
                            <button className="p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200 group"
                                onClick={() => navigate("/admin/settings")}
                            >
                                <MdSettings size={20} className="text-gray-600 group-hover:text-gray-800" />
                            </button>

                            {/* User Profile Dropdown */}
                            <div className="relative">
                                <button
                                    className="flex items-center space-x-3 p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200 group"
                                    onClick={() => setShowMenu(!showMenu)}
                                    id='context-trigger'
                                >
                                    {/* User Avatar */}
                                    <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-blue-600 rounded-full flex items-center justify-center">
                                        <MdPerson size={18} className="text-white" />
                                    </div>
                                    
                                    {/* User Name */}
                                    <div className="hidden sm:block text-left">
                                        <p className="text-sm font-medium text-gray-700 group-hover:text-gray-900">
                                            {user_data?.first_name} {user_data?.last_name}
                                        </p>
                                        <p className="text-xs text-gray-500">Administrator</p>
                                    </div>

                                    {/* Dropdown Arrow */}
                                    <svg 
                                        className={`w-4 h-4 text-gray-400 transform transition-transform duration-200 ${showMenu ? 'rotate-180' : ''}`}
                                        fill="none" 
                                        stroke="currentColor" 
                                        viewBox="0 0 24 24"
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                    </svg>
                                </button>

                                {/* Dropdown Menu */}
                                {showMenu && (
                                    <div className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50">
                                        {/* User Info Section */}
                                        <div className="px-4 py-3 border-b border-gray-100">
                                            <p className="text-sm font-medium text-gray-900">
                                                {user_data?.first_name} {user_data?.last_name}
                                            </p>
                                            <p className="text-xs text-gray-500 overflow-ellipsis max-w-48">{user_data?.email}</p>
                                        </div>

                                        {/* Menu Items */}
                                        {admin_context_menu.map((item, index) => (
                                            <button
                                                key={index}
                                                className="w-full flex items-center space-x-3 px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 transition-colors duration-200"
                                                onClick={() => {
                                                    item.onClick();
                                                    setShowMenu(false);
                                                }}
                                            >
                                                <span className="text-gray-400">{item.icon}</span>
                                                <span>{item.title}</span>
                                            </button>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            {/* Mobile Overlay */}
            {showMenu && isMobile(window.innerWidth) && (
                <div 
                    className="fixed inset-0 bg-black bg-opacity-25 z-40"
                    onClick={() => setShowMenu(false)}
                />
            )}
        </>
    )
}
